// moment with range
import origMoment from 'moment'
import * as mr from 'moment-range'
const moment = (((mr as any).default || mr) as typeof mr).extendMoment(
	origMoment as any
)

export default moment
